const VITE_PRELOAD_RELOAD_KEY = 'vite-preload-reload-at';
const VITE_PRELOAD_RETRY_WINDOW_MS = 60_000;

interface PreloadRecoveryDependencies {
  storage: Pick<Storage, 'getItem' | 'setItem'>;
  reload: () => void;
  now?: () => number;
}

export default function recoverFromVitePreloadError(
  event: Event,
  { storage, reload, now = Date.now }: PreloadRecoveryDependencies,
): boolean {
  const currentTime = now();

  try {
    const lastReloadAt = Number(storage.getItem(VITE_PRELOAD_RELOAD_KEY));
    const recentlyReloaded =
      Number.isFinite(lastReloadAt) &&
      lastReloadAt > 0 &&
      currentTime - lastReloadAt < VITE_PRELOAD_RETRY_WINDOW_MS;

    if (recentlyReloaded) return false;

    storage.setItem(VITE_PRELOAD_RELOAD_KEY, String(currentTime));
  } catch {
    return false;
  }

  event.preventDefault();
  reload();
  return true;
}
